<template>
	<div class="foot">
		<div>{{config.page_bottom}}</div>
		<div v-html="config.rights_reserved"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				config: {
					page_bottom: '',
					rights_reserved: ''
				}
			};
		},
		created() {
			this.config = JSON.parse(sessionStorage.getItem('configs'))
		},
		methods: {

		}
	};
</script>

<style scoped>
	/* 底部 */
	.foot {
		width: 100%;
		height: 100px;
		margin-top: 10px;
		background: rgba(6, 98, 179, 1);
		text-align: center;
	}

	.foot div:nth-child(1) {
		padding-top: 27px;
		height: 16px;
		font-size: 16px;
		font-weight: 400;
		color: #FFFFFF;
	}

	.foot div:nth-child(2) {
		margin-top: 15px;
		height: 16px;
		font-size: 16px;
		font-weight: 400;
		color: #FFFFFF;
	}
</style>
